import React, { FC, useState } from 'react'

import { Modal, Txt, StandardButton, Icon } from 'src/components/atoms'

import { useAuth, useToast } from 'src/hooks'
import { PasswordForceUpdateFormEntity, UserEntity } from 'src/types'

type Props = {
  user: UserEntity
  password: string
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
  afterUpdate?: () => void
}

export const ForceUpdatePasswordModal: FC<Props> = ({
  user,
  password,
  isOpen,
  onClose,
  onSuccess,
  afterUpdate,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { sendForceUpdateUserPasswordEmail, sendForceUpdateExternalUserPasswordEmail } = useAuth()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnReset = async () => {
    setIsLoading(true)

    const formEntity: PasswordForceUpdateFormEntity = {
      password,
      isSendEmail: false,
    }

    try {
      await (user.isExternal
        ? sendForceUpdateExternalUserPasswordEmail({ userId: user.id, formEntity })
        : sendForceUpdateUserPasswordEmail({ userId: user.id, formEntity }))

      onClose()
      displayStandardTextToast('パスワードリセット完了')
      onSuccess()
      afterUpdate && afterUpdate()
    } catch {
      displayErrorTextToast('パスワードリセットに失敗しました')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon
              size="--r1"
              path="refresh-ccw/soft/line"
              className="tw-accent-standardText-secondary"
            />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              パスワードリセット
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[37.86rem] tw-p-s2">
        <Txt>パスワードリセットを実行すると情報の復元はできません。本当によろしいですか？</Txt>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="リセット"
            prependIconPath="refresh-ccw/soft/line"
            isLoading={isLoading}
            size="l"
            onClick={handleOnReset}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
